import Api from '@/api/Api'
import store from '../store'

export default {
  async getLotList (params = {}) {
    return store.dispatch('checkResponseApi', await Api().get('inventory/lot-numbers', { params }))
  },

  async getLotLatestCode (params) {
    return store.dispatch('checkResponseApi', await Api().get('inventory/lot-numbers/latest-code', { params }))
  },

  async getLotSingle (id) {
    return store.dispatch('checkResponseApi', await Api().get(`inventory/lot-numbers/${id}`))
  },

  async createLot (data = {}) {
    const options = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
    return store.dispatch('checkResponseApi', await Api().post('inventory/lot-numbers', data, options))
  },

  async updateLot (id, data = {}) {
    const options = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
    return store.dispatch('checkResponseApi', await Api().put(`inventory/lot-numbers/${id}`, data, options))
  },

  async updateLotStatus (id, data = {}) {
    const options = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
    return store.dispatch('checkResponseApi', await Api().put(`inventory/lot-numbers/${id}/status`, data, options))
  },

  async deleteLot (id) {
    const options = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
    return store.dispatch('checkResponseApi', await Api().delete(`inventory/lot-numbers/${id}`))
  },
}



// WEBPACK FOOTER //
// ./src/api/LotService.js